export const mentionTypes = ['user', 'practitioner', 'location', 'surgeryType'] as const
export type MentionType = (typeof mentionTypes)[number]

export type BaseMentionItem = {
    id: string
    value: string
}

export type PractitionerMentionItem = BaseMentionItem & {
    type: 'practitioner'
    fullname: string
}

export type UserMentionItem = BaseMentionItem & {
    type: 'user'
}

export type LocationMentionItem = BaseMentionItem & {
    type: 'location'
}

export type SurgeryTypeMentionItem = BaseMentionItem & {
    type: 'surgeryType'
}

export type MentionItem = PractitionerMentionItem | UserMentionItem | LocationMentionItem | SurgeryTypeMentionItem
